import LabServiceModel from "@/models/LabServiceModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import UserModel from "./UserModel";
import LaboratoryModel from "./LaboratoryModel";
import ScheduleModel from "./ScheduleModel";
import InstrumentModel from "./InstrumentModel";

export default class ResultExportModel extends LabServiceModel {

  modelName() {
    return 'result-export';
  }

  icon() {
    return 'download';
  }

  defaults() {
    return {
      id: null,
      laboratory_id: null,
      user_id: null,
      status: null,
      schedule_id: null,
      sample_type_id: null,
      schedulable_process_type: null,
      schedulable_process_id: null,
      instrument_id: null,
      instrument_instance_id: null,
      tasks: null,
      date: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      status: (val) => (this.nullStringMutator(val)),
      schedule_id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      schedulable_process_type: (val) => (this.nullStringMutator(val)),
      schedulable_process_id: (val) => (this.nullStringMutator(val)),
      instrument_id: (val) => (this.nullStringMutator(val)),
      instrument_instance_id: (val) => (this.nullStringMutator(val)),
      //tasks: (val) => (this.nullArrayMutator(val)),
      date: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  validation() {
    return {}
  }

  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }

  getUser() {
    return this.getRelatedModel(UserModel, 'user');
  }

  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }

  getSchedule() {
    return this.getRelatedModel(ScheduleModel, 'schedule');
  }

  getInstrument() {
    return this.getRelatedModel(InstrumentModel, 'instrument');
  }

}
